import { AddressFormGroup } from '../forms/address-form-group';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CANADA_COUNTRY_ID } from '../consts/consts';
import { Address } from '../models/users/dto/address';

export class AddressFormFactory {
  public static createAddressForm(address?: Address): AddressFormGroup {
    return new FormGroup({
      addressLine1: new FormControl<string | null>(address?.addressLine1 ?? null, {
        validators: [Validators.required]
      }),
      addressLine2: new FormControl<string | null>(address?.addressLine2 ?? null),
      addressLine3: new FormControl<string | null>(address?.addressLine3 ?? null),
      city: new FormControl<string | null>(address?.city ?? null, { validators: [Validators.required] }),
      stateId: new FormControl<number | null>(address?.stateId ?? null, { validators: [Validators.required] }),
      countryId: new FormControl<number | null>(address?.countryId ?? CANADA_COUNTRY_ID, {
        validators: [Validators.required]
      }),
      postalCode: new FormControl<string | null>(address?.postalCode ?? null, { validators: [Validators.required] })
    });
  }
}
